export const LEADZAI_THEME_VARIANTS = ['default', 'coral', 'teal'] as const;

export type LeadzaiThemeVariant = (typeof LEADZAI_THEME_VARIANTS)[number];
